import React, { SetStateAction } from 'react'
import { Box, Button } from '@mui/material'
import { useLocale } from 'src/locales/useLocale'

type Props = {
  savedId: string
  isCopied: boolean
  setCopied: React.Dispatch<SetStateAction<boolean>>
}

export const SavedIdDisplay: React.FC<Props> = ({ savedId, isCopied, setCopied }) => {
  const { t } = useLocale()
  const handleCopy = (value: string) => {
    navigator.clipboard.writeText(value)
    setCopied(true)
  }
  if (savedId.length === 0) return <></>
  return (
    <Box ml={2} display="flex" justifyContent="center" alignItems="center">
      <Box mr={1} p={2} border={'solid 1px #eee'}>
        {t.SAVED_ID}：{savedId}
      </Box>
      <Button variant="outlined" color={'primary'} style={{ padding: '8px' }} onClick={() => handleCopy(savedId)}>
        {isCopied ? <>{t.COPIED}</> : <>{t.COPY}</>}
      </Button>
    </Box>
  )
}
